import { NgModule } from '@angular/core';
import { ShareModule } from "../share/share.module";
import { RouterModule } from '@angular/router';
//service
import { mainCampaignServices } from "./main-campaign.services";
//routes
import { MainCampaignRoutes as routes } from "./main-campaign.routes";
//components
import { MainCampaignComponent } from './main-campaign.component';
import { StepComponent } from './step/step.component';
import { OptionsComponent } from './options/options.component';
import { NewLineComponent } from './new-line/new-line.component';
import { PortInComponent } from './port-in/port-in.component';
import { ChangePlanComponent } from './change-plan/change-plan.component';
import { ComfirmationComponent } from './comfirmation/comfirmation.component';
import { ChangePlanStep2Component } from './change-plan/change-plan-step-2/change-plan-step-2.component';
import { ChangePlanStep3Component } from './change-plan/change-plan-step-3/change-plan-step-3.component';
import { NewLineStep2Component } from './new-line/new-line-step-2/new-line-step-2.component';
import { NewLineStep3Component } from './new-line/new-line-step-3/new-line-step-3.component';
import { PortInStep2Component } from './port-in/port-in-step-2/port-in-step-2.component';
import { PortInStep3Component } from './port-in/port-in-step-3/port-in-step-3.component';
import { NewLineStep1Component } from './new-line/new-line-step-1/new-line-step-1.component';
import { NewLineStep4Component } from './new-line/new-line-step-4/new-line-step-4.component';
import { PortInStep1Component } from './port-in/port-in-step-1/port-in-step-1.component';
import { ChangePlanStep1Component } from './change-plan/change-plan-step-1/change-plan-step-1.component';
import { PortInStep4Component } from './port-in/port-in-step-4/port-in-step-4.component';
import { ChangePlanStep4Component } from './change-plan/change-plan-step-4/change-plan-step-4.component';
import { OnlyNumber } from './../components/checkNumber';
import { SpecialCharacterDirective } from './../components/checkCharacterSpecial';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ModalModule} from "ngx-modal";

@NgModule({
  imports: [
    ShareModule,
    RouterModule.forChild(routes),
    InfiniteScrollModule,
    ModalModule
  ],
  providers:[
    mainCampaignServices
  ],
  exports:[
    MainCampaignComponent,
    StepComponent,
    OptionsComponent,
    ComfirmationComponent,

    //change plans
    ChangePlanComponent,
    ChangePlanStep2Component,
    ChangePlanStep3Component,

    //new line
    NewLineComponent,
    NewLineStep1Component,
    NewLineStep2Component,
    NewLineStep3Component,

    //port int
    PortInComponent,
    PortInStep2Component,
    PortInStep3Component
  ],
  declarations: [
    MainCampaignComponent,
    StepComponent,
    OptionsComponent,
    ComfirmationComponent,

    //change plans
    ChangePlanComponent,
    ChangePlanStep2Component,
    ChangePlanStep3Component,

    //new line
    NewLineComponent,
    NewLineStep1Component,
    NewLineStep2Component,
    NewLineStep3Component,

    OnlyNumber,
    SpecialCharacterDirective,

    //port int
    PortInComponent,
    PortInStep2Component,
    PortInStep3Component, NewLineStep4Component, PortInStep1Component, ChangePlanStep1Component, PortInStep4Component, ChangePlanStep4Component ]
})
export class MainCampaignModule { }
